<template>
  <div class="file-upload-container">
    <v-card
        outlined
        class="drop-zone transition-swing"
        :class="{ 'drop-zone--active elevation-5': isDragging, 'grey lighten-4': !currentFile && !progress }"
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave"
        @drop.prevent="onDrop"
    >
      <v-card-text class="d-flex flex-column align-center justify-center py-8">
        <template v-if="!currentFile && !progress">
          <v-icon size="64" :color="isDragging ? 'primary' : 'grey lighten-1'">
            mdi-cloud-upload-outline
          </v-icon>
          <div class="text-h6 mt-2 grey--text text--darken-2">
            {{ $t('Drag & Drop file here') }}
            {{ $t('Drag & Drop file here') }}
          </div>
          <div class="text-caption grey--text">{{ $t('or click to select') }}</div>
        </template>

        <template v-else-if="progress > 0 && progress < 100">
          <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="15"
              :value="progress"
              color="primary"
          >
            {{ progress }}%
          </v-progress-circular>
          <div class="text-subtitle-1 mt-4">{{ $t('Uploading...') }}</div>
        </template>

        <template v-else-if="currentFile">
          <v-icon size="64" color="success">mdi-file-check-outline</v-icon>
          <div class="text-subtitle-1 mt-2 font-weight-bold">{{ currentFile.name }}</div>
          <div class="text-caption grey--text">{{ (currentFile.size / 1024 / 1024).toFixed(2) }} MB</div>
        </template>

        <input
            ref="fileInput"
            type="file"
            style="display: none"
            @change="onFilePicked"
        >
      </v-card-text>
      
      <div v-if="!progress" class="click-overlay" @click="$refs.fileInput.click()"></div>
    </v-card>

    <v-alert v-if="message" border="left" color="blue-grey" dark v-html="message" class="mt-4" />
  </div>
</template>

<script>
import APIService from "@/services/APIService";

export default {
  name: "FileUpload",
  props: {
    unzipContent: { type: Boolean, required: true }
  },
  data() {
    return {
      currentFile: null,
      progress: 0,
      message: "",
      isDragging: false,
    };
  },
  methods: {
    onDragOver() { this.isDragging = true; },
    onDragLeave() { this.isDragging = false; },
    onDrop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        this.currentFile = files[0];
        this.upload(); // Direkt starten
      }
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files.length > 0) {
        this.currentFile = files[0];
        this.upload(); // Direkt starten
      }
    },
    async upload() {
      if (!this.currentFile) return;
      this.message = "";
      this.progress = 1; // Visueller Start
      this.$emit('started');
      
      APIService.upload(this.currentFile, (event) => {
        this.progress = Math.round((100 * event.loaded) / event.total);
      }, this.unzipContent).then((response) => {
        this.message = this.$t('File successfully uploaded');
        this.$emit('uploaded', response.data);
        this.currentFile = null;
        // Progress lassen wir kurz auf 100 oder resetten ihn später
        setTimeout(() => { this.progress = 0; }, 1000);
      }).catch((error) => {
        this.progress = 0;
        this.currentFile = null;
        this.message = `Fehler: ${error.response?.data?.message || 'Upload fehlgeschlagen'}`;
      });
    }
  }
}
</script>

<style scoped>
.drop-zone {
  position: relative;
  border: 2px dashed #bdbdbd !important;
  cursor: pointer;
}
.drop-zone--active {
  border-color: #1976d2 !important;
  background-color: #e3f2fd !important;
}
.click-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
